import { email, required, useRecordContext } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { useCrmIdentity } from "@/hooks/useCrmIdentity";

import type { Sale, UserRole } from "../types";

export function SalesInputs() {
  const { identity } = useCrmIdentity();
  const record = useRecordContext<Sale>();
  const isSelf = record?.id === identity?.id;

  const callerRole: UserRole =
    identity?.role || (identity?.administrator ? "admin" : "sales");
  const isSuperAdmin = callerRole === "superadmin";

  const recordRole: UserRole =
    record?.role || (record?.administrator ? "admin" : "sales");
  const isRecordSuperAdmin = recordRole === "superadmin";
  const isRecordAdmin = recordRole === "admin";

  // Standard admin cannot edit other administrators or superadmins
  const isBlockedByHierarchy =
    !isSuperAdmin && (isRecordSuperAdmin || (isRecordAdmin && !isSelf));

  const roleChoices = isSuperAdmin
    ? [
        { id: "sales", name: "Commerciale (Sales)" },
        { id: "admin", name: "Amministratore (Admin)" },
        { id: "superadmin", name: "Super Admin" },
      ]
    : [{ id: "sales", name: "Commerciale (Sales)" }];

  return (
    <div className="space-y-4 w-full">
      {isBlockedByHierarchy && (
        <div className="p-3 bg-amber-50 text-amber-800 text-sm rounded-md border border-amber-200">
          Questo profilo è gestibile solo da un Super Amministratore.
        </div>
      )}
      <TextInput
        source="first_name"
        validate={required()}
        readOnly={isBlockedByHierarchy}
        helperText={false}
      />
      <TextInput
        source="last_name"
        validate={required()}
        readOnly={isBlockedByHierarchy}
        helperText={false}
      />
      <TextInput
        source="email"
        validate={[required(), email()]}
        readOnly={isBlockedByHierarchy}
        helperText={false}
      />
      <SelectInput
        source="role"
        choices={roleChoices}
        defaultValue="sales"
        readOnly={isSelf || isBlockedByHierarchy}
        helperText={false}
      />
      <BooleanInput
        source="disabled"
        readOnly={isSelf || isBlockedByHierarchy}
        helperText={false}
      />
    </div>
  );
}
